export interface UnitResources {
  numero: number;
  pdfUrl: string;
  /** ID del episodio de Spotify. Se extrae de la URL:
   *  https://open.spotify.com/episode/ESTE_ES_EL_ID?si=xxx
   *  Ejemplo: '2uUwI2SgO9FXz1flW2plLR'
   */
  spotifyEpisodeId: string;
}


export const unitsResources: UnitResources[] = [
  {
    numero: 1,
    pdfUrl: '/pdfs/Capitulo 1.pdf',
    spotifyEpisodeId: '5tesKjJUPVat9NlifT7pnI',
  },
  {
    numero: 2,
    pdfUrl: '/pdfs/Capitulo 2.pdf',
    spotifyEpisodeId: '1dgX83LJnjqzb5oxpjEDOK',
  },
  {
    numero: 3,
    pdfUrl: '/pdfs/Capitulo 3.pdf',
    spotifyEpisodeId: '3jwZztCMqqv3cvYZZGkgxu',
  },
  {
    numero: 4,
    pdfUrl: '/pdfs/Capitulo 4.pdf',
    spotifyEpisodeId: '6ArrKL40JsJFdAYfNSzN7X',
  },
  {
    numero: 5,
    pdfUrl: '/pdfs/Capitulo 5.pdf',
    spotifyEpisodeId: '10ACprMEmA6T96bTfNH2ID',
  },
  {
    numero: 6,
    pdfUrl: '/pdfs/Capitulo 6.pdf',
    spotifyEpisodeId: '2MXKwAj0vYOfEipEGgNBQU',
  },
  {
    numero: 7,
    pdfUrl: '/pdfs/Capitulo 7.pdf',
    spotifyEpisodeId: '4mvKc0n9XRwUwFRqA2VqTM',
  },
  {
    numero: 8,
    pdfUrl: '/pdfs/Capitulo 8.pdf',
    spotifyEpisodeId: '6hOBMeaqwEy8ETyAyI1QZp',
  },
  {
    numero: 9,
    pdfUrl: '/pdfs/Capitulo 9.pdf',
    spotifyEpisodeId: '1qEYIRi52YWBWPBSiiqgQr',
  },
  {
    numero: 10,
    pdfUrl: '/pdfs/Capitulo 10.pdf',
    spotifyEpisodeId: '2uUwI2SgO9FXz1flW2plLR',
  },
  {
    numero: 11,
    pdfUrl: '/pdfs/Capitulo 11.pdf',
    spotifyEpisodeId: '6DtlUPZcNPQJ1N9L5RMqO4',
  },
  {
    numero: 12,
    pdfUrl: '/pdfs/Capitulo 12.pdf',
    spotifyEpisodeId: '3fJ5rGpfx4rp6w6Su4XeLi',
  },
  {
    numero: 13,
    pdfUrl: '/pdfs/Capitulo 13.pdf',
    spotifyEpisodeId: '5yiuie1wkDkldgBGesDIYE',
  },
  {
    numero: 14,
    pdfUrl: '/pdfs/Capitulo 14.pdf',
    spotifyEpisodeId: '4ydabugqMoWSRK5dAtYrDx',
  },
  {
    numero: 15,
    pdfUrl: '/pdfs/Capitulo 15.pdf',
    spotifyEpisodeId: '22kn2xPwhS6M0qeyQujdOM',
  },
];
